import $ from 'jquery';
import moment from 'moment';
window.$ = $;
window.jQuery = $;

require('jquery-ui/ui/widgets/datepicker')
require('jquery-ui/ui/widgets/dialog')
require('jquery-ui/ui/widgets/sortable')
require('jquery-ui/ui/widgets/tabs')
require('jquery-ui/ui/widget')
require('jquery-ujs')

import "../stylesheets/active_admin.scss"

import "@activeadmin/activeadmin"

// Import JSONEditor and assign it globally
import JSONEditor from 'jsoneditor/dist/jsoneditor.min.js'
window.JSONEditor = JSONEditor;

import "./jsoneditor_activeadmin_integration"
